import React from 'react';
import Modal, {
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
  OPACITY_LAYOUT_COLORS,
} from '@bit/gerenciatd.unifiedcomponents.modal';
import { LIGHT_BOX_CONTENT } from '@bit/gerenciatd.utils.tagging';
import { COLOR, BORDER } from '@bit/gerenciatd.unifiedcomponents.text-info';
import moment from 'moment';
import RetentionModal from '../../RetentionModal';
import PreventionModal from '../../PreventionModal';
import { VARIANT } from '../index';

const LONG_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
const FRONTFORMAT = 'DD/MM/YYYY';
const STR_FORMAT = 'YYYY-MM-DD';
export const changeTelcoFormatToFrontFormat = (dateString) => moment(dateString, LONG_FORMAT).format(FRONTFORMAT);
export const changeFrontFormatToCompatibleFormat = (dateString) => moment(dateString, FRONTFORMAT).format(STR_FORMAT);

const retentionModalHandler = (
  infoForRetentionModal,
  taggingInfoModal,
  forcedDisabled,
  isPrevention,
  onClickContinue
) => {
  return (
    <RetentionModal
      info={infoForRetentionModal}
      taggingInfoRetentionModal={taggingInfoModal}
      forcedDisabled={forcedDisabled}
      isPrevention={isPrevention}
      retentionOffer={false}
      onClickContinue={onClickContinue}
    />
  );
};

const preventionModalHandler = (
  infoForPreventionModal,
  taggingInfoModal,
  forcedDisabled
) => {
  return (
    <PreventionModal
      info={infoForPreventionModal}
      taggingInfoPreventionModal={taggingInfoModal}
      forcedDisabled={forcedDisabled}
    />
  );
};

export const showRetentionModal = (
  device,
  taggingInfo,
  infoForRetentionModal,
  forcedDisabled,
  taggingInfoModal,
  isPrevention,
  onClickContinue
) => {
  Modal.setModalProps({
    contentPosition:
      device === 'mobile'
        ? CONTENT_POSITION.CENTER_TOP
        : CONTENT_POSITION.CENTER_CENTER,
    opacityLayoutColor:
      device === 'mobile'
        ? OPACITY_LAYOUT_COLORS.WHITE
        : OPACITY_LAYOUT_COLORS.BLACK05,
    inSceneEffect:
      device === 'mobile'
        ? IN_SCENE_EFFECT.FADE_IN
        : IN_SCENE_EFFECT.FADE_IN_RIGHT,
    outSceneEffect:
      device === 'mobile'
        ? OUT_SCENE_EFFECT.FADE_OUT
        : OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
    closeByClickingOutside: device !== 'mobile',
    contentInsideContainer: false,
    scrollAllowed: false,
    show: true,
    className: 'RetentionModalContainer',
    taggingInfoWhenClickingOutside: {
      ...taggingInfo,
      componentContent: LIGHT_BOX_CONTENT.CLICK_OUTSIDE,
      componentName: 'retentionModal',
    },
  });
  if (
    infoForRetentionModal.aliasProduct
    && infoForRetentionModal.hiredAliasProduct
  ) {
    Modal.setContent(
      retentionModalHandler(
        infoForRetentionModal,
        taggingInfoModal,
        forcedDisabled,
        isPrevention,
        onClickContinue
      )
    );
  }
  Modal.show();
};

export const showPreventionModal = (
  device,
  taggingInfo,
  infoForPreventionModal,
  forcedDisabled,
  taggingInfoModal
) => {
  Modal.setModalProps({
    contentPosition:
      device === 'mobile'
        ? CONTENT_POSITION.CENTER_TOP
        : CONTENT_POSITION.CENTER_CENTER,
    opacityLayoutColor:
      device === 'mobile'
        ? OPACITY_LAYOUT_COLORS.WHITE
        : OPACITY_LAYOUT_COLORS.BLACK05,
    inSceneEffect:
      device === 'mobile'
        ? IN_SCENE_EFFECT.FADE_IN
        : IN_SCENE_EFFECT.FADE_IN_RIGHT,
    outSceneEffect:
      device === 'mobile'
        ? OUT_SCENE_EFFECT.FADE_OUT
        : OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
    closeByClickingOutside: device !== 'mobile',
    contentInsideContainer: false,
    scrollAllowed: false,
    show: true,
    className: 'RetentionModalContainer',
    taggingInfoWhenClickingOutside: {
      ...taggingInfo,
      componentContent: LIGHT_BOX_CONTENT.CLICK_OUTSIDE,
      componentName: 'preventionModal',
    },
  });
  if (
    infoForPreventionModal.aliasProduct
    && infoForPreventionModal.hiredAliasProduct
  ) {
    Modal.setContent(
      preventionModalHandler(
        infoForPreventionModal,
        taggingInfoModal,
        forcedDisabled
      )
    );
  }
  Modal.show();
};
/**
 * calcula el color en función dle peso d elos atributos
 * @param {number} hiredWeight peso del atributo contratado
 * @param {number} defaultWeight peso del atributo a comparar
 * @param {boolean} hideColors flag para poner o no los colores al comparar
 * @param {string} variant variante del producto
 * @returns{string}
 */
export const calculateColor = ({
  hiredWeight, defaultWeight, hideColors, variant,
}) => {
  if (!hideColors) {
    if (variant === VARIANT.HIRED) {
      if (hiredWeight && !defaultWeight) {
        return COLOR.RED;
      }
      if (defaultWeight < hiredWeight) {
        return COLOR.RED;
      }
      if (defaultWeight === hiredWeight) {
        return COLOR.BLACK;
      }
    }
    return COLOR.BLACK;
  }
  return COLOR.BLACK;
};

/**
 * obtiene el color del icino principal de cada atributo del productitem
 * @param {string} variant variante del producto
 * @returns {srtring}
 */
export const getSvgIconColor = (variant) => {
  let svgColor = COLOR.BLUE;
  if (variant === VARIANT.HIRED || variant === VARIANT.VINTAGE) {
    svgColor = COLOR.EGG;
  } else if (variant === VARIANT.RECOMMENDED) {
    svgColor = COLOR.GREEN;
  }
  return svgColor;
}

/**
 * obtiene el el borde del textInfo
 * @param {number} hiredWeight peso del atributo contratado
 * @param {number} defaultWeight peso del atributo a comparar
 * @param {boolean} hideColors flag para poner o no los colores al comparar
 * @param {string} variant variante del producto
 * @returns {string} forma del borde
 */
export const getBorderShape = (
  hiredWeight,
  defaultWeight,
  hideColors,
  variant,
) => {
  let border = null;
  const color = calculateColor({
    hiredWeight,
    defaultWeight,
    hideColors,
    variant,
  })
  if (color === COLOR.RED) {
    border = BORDER.ROUNDED;
  }
  return border;
}

/**
 * obtiene el color de fondo de cada atribuo
 * @param {number} hiredWeight peso del atributo contratado
 * @param {number} defaultWeight peso del atributo a comparar
 * @param {boolean} hideColors flag para poner o no los colores al comparar
 * @param {string} variant variante del producto
 * @returns {string}
 */
export const calculateBackgroundColorFeature = ({
  hiredWeight,
  defaultWeight,
  hideColors,
  variant,
}) => {
  let backgroundColor = null;
  const color = calculateColor({
    hiredWeight,
    defaultWeight,
    hideColors,
    variant,
  })
  if (color === COLOR.RED) {
    backgroundColor = COLOR.GREY_3;
  }
  return backgroundColor;
}

export const getFusionFeatures = (commerInfo) => {
  let tv = null;
  let movil = null;
  let internet = null;
  let smartPhone = null;
  if (commerInfo && Array.isArray(commerInfo)) {
    commerInfo.forEach((feature) => {
      if (feature.alias.includes('ic_tv')) {
        tv = feature;
      }
      if (feature.alias.includes('ic_movil')) {
        movil = feature;
      }
      if (feature.alias.includes('ic_internet')) {
        internet = feature;
      }
      if (feature.alias.includes('ic_smartphone')) {
        smartPhone = feature;
      }
    })
  }
  return { tv, movil, internet, smartPhone }
}
